<template>
  <div>


    <b-row>
      <b-col md="9">
        <h4 class="font-weight-bold ml-1">Ordrer</h4>
      </b-col>

      <b-col md="1">
        <div class="float-right">
          <label class="nav-item navbar-text navbar-search-box p-0 active">
            <i class="ion ion-ios-search navbar-icon align-middle"></i>
            <span class="navbar-search-input pl-2">
              <b-form-input
                class="ml-2"
                v-model="filter"
                placeholder="Søk"
              ></b-form-input>
            </span>
          </label>
        </div>
      </b-col>

      <b-col md="2">
        <b-button
          class="float-right"
          variant="primary"
          @click="newOrder()"
        >Ny bestilling</b-button>
      </b-col>

    </b-row>

    <!-- User Interface controls -->

    <!-- Main table element -->

    <div>
      <b-table
        show-empty
        caption-top
        stacked="sm"
        :items="orders"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortAcs"
        :sort-direction="sortDirection"
        :hover="hoverTable"
        empty-text="There are no orders to show"
      >

        <!-- @row-clicked="(item) => $set(item, '_showDetails', !item._showDetails)" -->

        <template v-slot:table-caption>Total: {{ orders.length | numeralFormat }} ordrer
        </template>

        <template v-slot:cell(status)="data">
          <b-badge pill v-if="data.item.status == 'Bestilling'" variant="secondary">{{ data.item.status }} </b-badge>
          <b-badge pill v-if="data.item.status == 'Ordre'" variant="primary">{{ data.item.status }}</b-badge>
          <b-badge pill v-if="data.item.status == 'I arbeid'" variant="dark">{{ data.item.status }}  </b-badge>
          <b-badge pill v-if="data.item.status == 'Arbeid avsluttet'" variant="warning">{{ data.item.status }}</b-badge>
          <b-badge pill v-if="data.item.status == 'Til fakturering'" variant="info">Utført</b-badge>
          <b-badge pill v-if="data.item.status == 'Fakturert'" variant="success">Utført</b-badge>
          <b-badge pill v-if="data.item.status == 'Utført'" variant="success">Utført</b-badge>
          <b-badge pill v-if="data.item.status == 'Kansellert'" variant="danger">{{ data.item.status }}</b-badge>
        </template>

        <template v-slot:cell(ordertitle)="data">
          <b-link class="link" :href="'#/customer/order-view/' + data.item.id">
            <span v-if="data.item.supplier_company != null">
              {{ data.item.ordernumber}} - {{ data.item.supplier_company.name }}
              <span v-if="data.item.site != null">({{ data.item.site.name }})</span></span>
          </b-link>
        </template>

        <template v-slot:cell(site)="data">
          <span v-if="data.item.site != null">
            {{ data.item.site.name }}
          </span>
        </template>

        <template v-slot:cell(vessel)="data">
          <span v-if="data.item.vessel != null">{{ data.value }}</span>
        </template>

        <template v-slot:cell(createdAt)="data">
          {{ data.value | $date("from") }}
        </template>

        <template v-slot:cell(startdate)="data">
         {{
            $date(data.value).format("DD.MM.YYYY")
          }}
        </template>

        <template v-slot:cell(enddate)="data">
         {{
            $date(data.value).format("DD.MM.YYYY")
          }}
        </template>

        <template v-slot:cell(updatedAt)="data">
          {{ data.value | $date("from") }}
        </template>

        <template v-slot:cell(attachments)="data">
          <span v-if="data.item.attachments.length != 0"><i class="ion ion-ios-attach"></i></span>
        </template>

        <!-- <template #row-details="row">
          <b-card>
            <b-row>
              <b-col>
                <vue-json-pretty :data="row.item.supplier_company">
                </vue-json-pretty>
              </b-col>

              <b-col>
                <vue-json-pretty :data="row.item.site">
                </vue-json-pretty>
              </b-col>

              <b-col>
                <vue-json-pretty :data="row.item.details">
                </vue-json-pretty>
              </b-col>

            </b-row>

            <b-button
              variant="primary"
              size="sm"
              @click="row.toggleDetails"
            >Hide Details</b-button>
          </b-card>
        </template> -->
      </b-table>

      <b-row>
        <b-col
          md="1"
          class="my-1"
        >
          <b-form-group class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col
          md="2"
          class="my-1"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>

    <br />
  </div>
</template>

<script>
import axios from "axios";

import Datepicker from "vuejs-datepicker";




export default {
  components: {

    Datepicker,
    
  },
  data() {
    return {
      order: {},
      orders: [],
      lastUpdate: {},
      fromDate: {},
      toDate: {},
      disabledDates: {},
      fields: [
        { key: "status", label: "Status", sortable: true },
        {
          key: "ordertitle",
          label: "Ordre",
          sortable: true,
          class: "text-left",
        },
        { key: "type", label: "Type", sortable: true },
        { key: "vessel.name", label: "Fartøy", sortable: true },
        { key: "startdate", label: "Startdato", sortable: true },
        {
          key: "updatedAt",
          label: "Sist oppdatert",
          sortable: true,
        },
        {
          key: "attachments",
          label: "",
        }
      ],
      typeOptions: [
        { value: "Avslusning", text: "Avslusning" },
        { value: "Notspyling", text: "Notspyling" },
        { value: "Servicearbeid", text: "Servicearbeid" },
      ],
      statusOptions: [
        { value: "Bestilling", text: "Bestilling" },
        { value: "Ordre", text: "Ordre" },
        { value: "I arbeid", text: "I arbeid" },
        { value: "Arbeid avsluttet", text: "Arbeid avsluttet" },
        { value: "Utført", text: "Utført" },
        { value: "Kansellert", text: "Kansellert" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [25, 50, 100, 250, 500, 1000],
      sortBy: "created",
      sortDesc: true,
      sortDirection: "desc",
      filter: null,
      hoverTable: true,
      limit: 1000,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sumOrdersTotal() {
      return this.orders.length;
    },
  },
  methods: {
    getOrders() {
      this.isLoading = true;
      var company = localStorage.getItem("company");
      axios
        .get(
          "https://api.eines-as.no/orders?_sort=createdAt:DESC&_where[customer_company]=" +
            company
        )
        .then((res) => {
          this.orders = res.data;
          this.isLoading = false;
        });
    },
    updateOrders() {
      this.isLoading = true;
      axios.get("https://api.eines-as.no/orders").then((res) => {
        this.orders = res.data;
        this.isLoading = false;
      });
    },
    newOrder() {
      this.$router.push("/customer/neworder");
    },
    showOrder(orderId) {
        this.$router.push("/customer/order-view/" + orderId);
      },
  },
  created: function () {
    this.getOrders();
  },
};
</script>

<style lang="css">
.country-flag {
  max-width: 20px;
  box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
}

.background-white {
  background: #ffffff;
}

/*
 * Link
 */

/* Links */

.link {
  color: #484848;
}

/* unvisited link */
.link:link {
  color: #484848 !important;
}

/* visited link */
.link:visited {
  color: #484848 !important;
}

/* mouse over link */
.link:hover {
  color: #6e6e6e !important;
}

/* selected link */
.link:active {
  color: #484848 !important;
}
</style>